import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom"
import { BaseButton } from "../../components/BaseButton/BaseButton";
import { BaseNumberBox } from "../../components/BaseNumberBox/BaseNumberBox";
import { Content } from "../../Enums/contents"
import {
    ROUTE_ADD_SECURITY_COST,
    ROUTE_FY_COST_ESTIMATE
} from "../../routes/Routes";
import FiscalYearDropdown from "./FiscalYearDropdown"
import PutPostPatchFetch from "../../hooks/PutPostPatchFetch";
import { useAuth } from "../../hooks/useAuth";
import BaseNotification from "../../components/BaseNotification/BaseNotification";
import usePageTitle from "../../hooks/usePageTitle";
import BldgNumberDropDownDevEx from "../../components/BldgNumberDropDownDevEx";

const {
    Buttons: {
        cancel,
        submit,
        MUI: {
            Variant: {
                outlined
            }
        }
    },
    Inputs: {
        labelModes: {
            _static
        },
        Input_NumberBox_Label: {
            pmoChargesLabel,
            tcmChargesLabel
        },
        Input_SelectField_Labels: {
            fiscalYearLabel
        }
    },
    NummberFormatting: {
        currencyFormat
    }
} = Content;

const AddSecurityCost = () => {
    const { title } = ROUTE_ADD_SECURITY_COST;
    const navigate = useNavigate();
    const { user } = useAuth();
    const [buildingSeqNo, setBuildingSeqNo] = useState('');
    const [fiscalYear, setFiscalYear] = useState('');
    const [psoCharge, setPSOcharge] = useState(0);
    const [tcmCharge, setTCMcharge] = useState(0);
    const [canSubmitForm, setCanSubmitForm] = useState(false);
    const [notification, setNotification] = useState({
        message: '',
        type: undefined,
        visible: false
    });

    usePageTitle(title);
    useEffect(() => {
        validValues();
    }, [
        fiscalYear,
        buildingSeqNo,
        psoCharge,
        tcmCharge
    ]);
  useEffect(() => {
    validatePSOCharge();
    validatePSOCharge();
  }, [
    psoCharge,
    tcmCharge
  ])
    const returnToCostEstimatePage = () => {
        navigate(ROUTE_FY_COST_ESTIMATE.withSlash);
    };

    const validValues = () => {
        const result = (
            validateSqNo(buildingSeqNo)
            && validatePSOCharge(psoCharge)
            && validateTcmCharge(tcmCharge)
            && validateFiscalYear(fiscalYear)           
            );

        setCanSubmitForm(result);
    };
    const validateSqNo = (buildingSeqNo)=>{
        if (!buildingSeqNo || buildingSeqNo == undefined || buildingSeqNo == '' || buildingSeqNo === 'None') {
            return false;
        };
        return true;
    }
    
    const validatePSOCharge = ()=>{
        if(psoCharge <= 0 && tcmCharge <= 0)    
        return false ;
        if(psoCharge < 0)
        return false ;
       return true ; 
    }

    const validateTcmCharge = ()=>{
        if(psoCharge <= 0 && tcmCharge <= 0)    
        return false ;
        if(tcmCharge < 0)
        return false ;
      return true ; 
}

  const validateFiscalYear = (fiscalYear)=>{
    if (!fiscalYear ||fiscalYear == undefined || fiscalYear == '' || isNaN(fiscalYear) ){
        return false;
    }
    return true;  }

    const handleCreate = async () => {
        if (!canSubmitForm) {
            console.error('Can\'t be submitted', securityCost)
            return;
        };

        let convertedTcmCharge;
        let convertedPsoCharge;

        try {
            convertedTcmCharge = parseInt(tcmCharge);
            convertedPsoCharge = parseInt(psoCharge);
 
            if (isNaN(convertedTcmCharge) || isNaN(convertedPsoCharge)) {
                setNotification({
                    message: 'Please enter a value that is a number.',
                    type: 'error',
                    visible: true
                });
            }
        } catch (ex) {
            setNotification({
                message: `The charge you entered is not a number. Please review your input and ensure that charges entered are numeric.`,
                type: 'error',
                visible: true
            });
        }
        const securityCost = {
            "CreatedBy": user.email,
            "BuildingSequenceNumber": buildingSeqNo,
            "FiscalYear": fiscalYear,
            "TcmCharge": convertedTcmCharge,
            "PsoCharge": convertedPsoCharge,
            "AmortCapCharge": 0,
            "ChargesYtd": 0,
            "AdjustmentCharges": 0,
            "AdjustmentChargesYtd": 0,
            "ApprovalStatus":"Submitted"
        };
        
        const { Success, Errors } = await PutPostPatchFetch('/v1/SecurityCost/Multi', 'POST', securityCost);

        if (Success) {
            setNotification({
                message: `New Security for Building Number ${buildingSeqNo} was saved, successfully.`,
                type: 'success',
                visible: true
            });
        }
        else {
            setNotification({
                message: Errors[0].Message,
                type: 'error',
                visible: true
            });
        };
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleCreate();
        };
    };

    const handleToastHiding = () => {
        setNotification(() => ({ 
            message: '',
            type: undefined, 
            isVisible: false
        }))
    };

    return (
        <div>
            <h1 style={{ color: "#06152B" }}>{title}</h1>
            <form className="inline__div--wrapper" method="post">
                 <BldgNumberDropDownDevEx
                        value={buildingSeqNo}
                        setter={setBuildingSeqNo}
                        isRequired ={true}
                      
                    />
                <FiscalYearDropdown
                    inputAttribute={{ "aria-label": "Fiscal Year *" }}
                    enableSearch={true}
                    label={fiscalYearLabel}
                    onEnterKeyDown={handleKeyDown}
                    value={fiscalYear}
                    optionUpdatedByUser={
                        ({ selectedItem }) => setFiscalYear(selectedItem)
                    }
                    isVisible={true}
                />
                <BaseNumberBox
                        inputAttribute={{ "aria-label": "PSO Charges" }}
                        label={pmoChargesLabel}
                        labelMode={_static}
                        numberFormat={currencyFormat}
                        isValueValid = {validatePSOCharge()}
                        onEnterKeyDown={handleKeyDown}
                        value={psoCharge}
                        validationRuleCallback={() => validatePSOCharge()}
                        valueUpdatedByUser={
                            ({ value }) => setPSOcharge(value)
                        }
                        validationRequired = {true}
                        errMsg = "Please provide a valid value."
                />
                <BaseNumberBox
                    inputAttribute={{ "aria-label": "TCM Charges" }}
                    label={tcmChargesLabel}
                    labelMode={_static}
                    numberFormat={currencyFormat}
                    isValueValid = {validateTcmCharge()}
                    onEnterKeyDown={handleKeyDown}
                    value={tcmCharge}
                    validationRuleCallback={() => validatePSOCharge()}
                    valueUpdatedByUser={
                        ({ value }) => setTCMcharge(value)
                    }
                    validationRequired = {true}
                    errMsg = "Please provide a valid value."
                />
            </form>
            <div className="break"></div>
            <div className="block--flex-items">
            <BaseButton
                    ariaDisabled={canSubmitForm === false}
                    disabled={canSubmitForm === false}
                    label={submit}
                    onClick={handleCreate}
                    variant={outlined}
                />                
                <BaseButton
                    label={cancel}
                    variant={outlined}
                    onClick={returnToCostEstimatePage}
                />
            </div>
            <BaseNotification 
                message={notification.message}
                ref={useRef(null)}
                setter={() => setNotification(() => (
                    { 
                        isVisible: false,
                        message: '',
                        type: undefined
                    }
                ))}
                type={notification.type}
                visible={notification.visible}
            />
        </div >       
    );
};

export default AddSecurityCost;